import React, { useEffect, useState } from 'react'
import { IPFStoURL, formatPrice, getCurrentChain, shorterDate, trimAddress } from '../helper/functions';
import { CHAIN_INFO, DEFAULT_IMAGES } from '../helper/constant';
import { useSelector } from 'react-redux';
import Layout from '../components/Layout';
import { api } from '../helper/api';
import localStorage from 'local-storage';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { useAccount } from 'wagmi';

export default function MyProfile() {
    const { chainId } = useAccount();
    const currentChain = getCurrentChain(chainId)
    const profile = useSelector((state) => state.user.profile);
    const banner = useSelector((state) => state.user.banner);
    const account = useSelector((state) => state.user.address);
    const username = useSelector((state) => state.user.username);
    const [tab, setTab] = useState(1);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        pageLimit: 8,
        totalPages: 1,
        totalRecords: 0,
        loading: true,
        tabId: tab
    })

    const [nftData, setNftData] = useState([]);

    useEffect(() => {
        async function fetch() {
            let token = localStorage.get('auth_token');
            let collectionNFTs;

            if (tab === 2) {
                collectionNFTs = await api.post('users/offer-made', {
                    token,
                    page: pagination.currentPage,
                    limit: pagination.pageLimit,
                })
            } else if (tab === 3) {
                collectionNFTs = await api.post('users/nft-activity', {
                    token,
                    page: pagination.currentPage,
                    limit: pagination.pageLimit,
                })
            } else if (tab === 4) {
                collectionNFTs = await api.post('users/sale-activity', {
                    token,
                    page: pagination.currentPage,
                    limit: pagination.pageLimit,
                })
            }
            else {
                collectionNFTs = await api.post('users/collected', {
                    token,
                    page: pagination.currentPage,
                    limit: pagination.pageLimit,
                })
            }

            if (collectionNFTs && collectionNFTs.data && collectionNFTs.data.data) {
                setNftData(collectionNFTs.data.data)
                setPagination(prev => ({
                    ...prev,
                    totalPages: collectionNFTs.data.totalPages,
                    totalRecords: collectionNFTs.data?.totalRecord,
                    loading: false
                }));
            }
        }

        if (account) {
            fetch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagination.currentPage, account, pagination.tabId])

    useEffect(() => {
        setPagination({
            currentPage: 1,
            pageLimit: 8,
            totalPages: 1,
            totalRecords: 0,
            loading: true,
            tabId: tab
        })
    }, [tab])


    const handlePageChange = (page) => {
        let newPage;

        if (page === 'prev' && parseInt(pagination.currentPage) - 1 >= 1) {
            newPage = Math.max(1, parseInt(pagination.currentPage) - 1);
        } else if (page === 'next' && parseInt(pagination.currentPage) < parseInt(pagination.totalPages)) {
            newPage = Math.min(parseInt(pagination.totalPages), parseInt(pagination.currentPage) + 1);
        } else {
            // If it's not 'prev' or 'next', set the newPage to the selected page
            newPage = parseInt(page);
        }

        // Check if the current page is different from the new page
        if (newPage !== parseInt(pagination.currentPage)) {
            setPagination((prevPagination) => ({
                ...prevPagination,
                currentPage: newPage,
                loading: true
            }));
        }
    };


    return (
        <Layout>
            <div class="no-bottom no-top" id="content">
                <section
                    id="profile_banner"
                    aria-label="section"
                    className="text-light"
                    style={{
                        backgroundImage: `url('${banner ? IPFStoURL(banner) : IPFStoURL(DEFAULT_IMAGES.profile.banner)}')`,
                        backgroundPosition: 'center',

                    }}
                ></section>

                <div aria-label="section">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="align-items-center d_profile de-flex">
                                    <div class="de-flex-col">
                                        <div class="profile_avatar">
                                            <img src={profile ? IPFStoURL(profile) : IPFStoURL(DEFAULT_IMAGES.profile.profile)} alt="profile" />
                                            <i class="fa fa-check"></i>
                                            <div class="profile_name">
                                                <h4>
                                                    {username ? username : '--'}
                                                    <span class="profile_username">
                                                        {account ? trimAddress(account) : '--'}
                                                    </span>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className='col-12'>
                                <div className='d-flex justify-content-center'>
                                    <Button onClick={() => setTab(1)} variant={`${tab === 1 ? 'contained' : 'outlined'}`} className='mx-1'>All Nfts</Button>
                                    <Button onClick={() => setTab(2)} variant={`${tab === 2 ? 'contained' : 'outlined'}`} className='mx-1'>Offers made</Button>
                                    <Button onClick={() => setTab(3)} variant={`${tab === 3 ? 'contained' : 'outlined'}`} className='mx-1'>NFTs Activity</Button>
                                    <Button onClick={() => setTab(4)} variant={`${tab === 4 ? 'contained' : 'outlined'}`} className='mx-1'>Sale Activity</Button>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="de_tab tab_simple">
                                    <div class="de_tab_content">
                                        <div class="row">
                                            {pagination.loading ? (
                                                <div class="d-flex justify-content-center align-items-center vh-100">
                                                    <div class="spinner-border" role="status" id="loading">
                                                        <span class="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    {nftData && nftData.length === 0 ? (
                                                        <div class="d-flex justify-content-center align-items-center vh-100">
                                                            No Data Found
                                                        </div>
                                                    ) : (
                                                        <>
                                                            {(tab === 1 || tab === 2) &&
                                                                nftData.map((items, key) => {
                                                                    console.log(items);
                                                                    let metadata = items.metaData ? JSON.parse(items.metaData) : {};
                                                                    let currencyInfo = CHAIN_INFO[currentChain].currency_support.filter((values) => items.ERC20Token && values.address.toLowerCase() === items.ERC20Token.toLowerCase())
                                                                    items.currencyInfo = currencyInfo.length > 0 ? currencyInfo[0] : CHAIN_INFO[currentChain].currency_support[0];
                                                                    return (
                                                                        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12" key={key}>
                                                                            <div class="nft__item style-2">

                                                                                <div class="nft__item_wrap">
                                                                                    <Link to={`/${items.nft_address}/${items.tokenId}`}>
                                                                                        <img src={metadata && metadata.image ? IPFStoURL(metadata.image) : IPFStoURL(DEFAULT_IMAGES.profile.profile)} class="lazy nft__item_preview" alt="nft" />
                                                                                    </Link>
                                                                                </div>
                                                                                <div className=''>


                                                                                    <div class="d-flex align-items-center user-profile">
                                                                                        <div class="image mx-2">
                                                                                            <img src={items.user_profile ? IPFStoURL(items.user_profile) : IPFStoURL(DEFAULT_IMAGES.profile.profile)} alt='profile' class="rounded" width="24px" height="24px" />
                                                                                        </div>
                                                                                        <div class="ml-3 w-100">
                                                                                            <h4 class="mb-0 mt-0">{items.username ? items.username : trimAddress(items.owner)}</h4>
                                                                                            <span>{items.owner ? trimAddress(items.owner) : '- -'}</span>
                                                                                        </div>
                                                                                    </div>



                                                                                </div>
                                                                                <div class="nft__item_info p-2">
                                                                                    <div className='d-flex justify-content-between'>
                                                                                        <Link to={`/${items.nft_address}/${items.tokenId}`}>
                                                                                            <h4>{metadata.name ? metadata.name : `${items.col_name}`} #{items.tokenId}</h4>
                                                                                        </Link>
                                                                                        <span>{items.balance}X</span>
                                                                                    </div>
                                                                                    <div className='d-flex justify-content-between '>
                                                                                        <div class="nft__item_price">
                                                                                            <span>{items.nftHighestBid > 0 ? formatPrice(items.nftHighestBid / Math.pow(10, 18)) : items.order_price > 0 ? formatPrice(items.order_price / Math.pow(10, 18)) : ' - - '} {items.currencyInfo.symbol}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })}

                                                            {tab === 3 &&

                                                                <table class="table de-table table-responsive">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col">Event Type</th>
                                                                            <th scope="col">Item</th>
                                                                            <th scope="col">Quantity</th>
                                                                            <th scope="col">From</th>
                                                                            <th scope="col">To</th>
                                                                            <th scope="col">Time</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            nftData.map((items, key) => {
                                                                                let metadata = items.metaData ? JSON.parse(items.metaData) : {};
                                                                                return (
                                                                                    <tr key={key}>
                                                                                        <td>
                                                                                            {items?.event_type}
                                                                                        </td>
                                                                                        <td>
                                                                                            <div class="d-flex align-items-center user-profile">
                                                                                                <div class="image mx-2">
                                                                                                    <img src={metadata.image ? IPFStoURL(metadata.image) : IPFStoURL(DEFAULT_IMAGES.profile.profile)} alt='profile' class="rounded" width="24px" height="24px" />
                                                                                                </div>
                                                                                                <div class="ml-3 w-100">
                                                                                                    <h6 class="mb-0 mt-0">{metadata.name ? metadata.name : '--'}</h6>
                                                                                                    <span>{items.col_name ? items.col_name : trimAddress(items.nft_address)}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </td>
                                                                                        <td>{items.amount ? formatPrice(items.amount) : 0}</td>
                                                                                        <td>{items.sender ? trimAddress(items.sender) : ' - '}</td>
                                                                                        <td>{items.owner ? trimAddress(items.owner) : ' - '}</td>
                                                                                        <td>
                                                                                            <span className='mx-1'>{items.created ? new Date(items.created).toLocaleDateString() : ' - '}</span>
                                                                                            <a target='_blank' href={`${CHAIN_INFO[currentChain].explorer}/tx/${items.tokenHash}`} rel="noreferrer">
                                                                                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
                                                                                            </a>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }


                                                                    </tbody>
                                                                </table>
                                                            }

                                                            {tab === 4 &&

                                                                <table class="table de-table table-responsive">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col">Event Type</th>
                                                                            <th scope="col">Sale Type</th>
                                                                            <th scope="col">Item</th>
                                                                            <th scope="col">Quantity</th>
                                                                            <th scope="col">Price</th>
                                                                            <th scope="col">Start</th>
                                                                            <th scope="col">End</th>
                                                                            <th scope="col">Highest Bidder</th>
                                                                            <th scope="col">Highest Bid</th>
                                                                            <th scope="col">Status</th>
                                                                            <th scope="col">Time</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            nftData.map((items, key) => {
                                                                                let metadata = items.metaData ? JSON.parse(items.metaData) : {};
                                                                                let currencyInfo = CHAIN_INFO[currentChain].currency_support.filter((values) => items.ERC20Token && values.address.toLowerCase() === items.ERC20Token.toLowerCase())
                                                                                items.currencyInfo = currencyInfo.length > 0 ? currencyInfo[0] : CHAIN_INFO[currentChain].currency_support[0];
                                                                                return (
                                                                                    <tr key={key}>
                                                                                        <td>
                                                                                            {items?.event_type}
                                                                                        </td>
                                                                                        <td>
                                                                                            {items.saletype ? items.saletype === "1" ? 'Sale' : 'Auction' : '-'}
                                                                                        </td>
                                                                                        <td>
                                                                                            <div class="d-flex align-items-center user-profile">
                                                                                                <div class="image mx-2">
                                                                                                    <img src={metadata.image ? IPFStoURL(metadata.image) : IPFStoURL(DEFAULT_IMAGES.profile.profile)} alt='profile' class="rounded" width="24px" height="24px" />
                                                                                                </div>
                                                                                                <div class="ml-3 w-100">
                                                                                                    <h6 class="mb-0 mt-0">{metadata.name ? metadata.name : '--'}</h6>
                                                                                                    <span>{items.col_name ? items.col_name : trimAddress(items.nft_address)}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </td>
                                                                                        <td>{items.left_amount ? formatPrice(items.left_amount) : 0}</td>
                                                                                        <td>{items.nftHighestBid > 0 ? formatPrice(items.nftHighestBid / Math.pow(10, 18)) : formatPrice(items.price / Math.pow(10, 18))} {items.currencyInfo.symbol}</td>
                                                                                        <td>{items.auctionStart > 0 ? shorterDate(items.auctionStart * 1000) : ' - '}</td>
                                                                                        <td>{items.auctionEnd > 0 ? shorterDate(items.auctionEnd * 1000) : ' - '}</td>
                                                                                        <td>{items.nftHighestBidder ? trimAddress(items.nftHighestBidder) : ' - '}</td>
                                                                                        <td>{items.nftHighestBid ? formatPrice(items.nftHighestBid / Math.pow(10, 18)) : ' - '} {items.currencyInfo.symbol}</td>
                                                                                        <td>{items.status === '0' ? "Active" : items.status === '1' ? 'Finished' : 'Canceled'}</td>
                                                                                        <td>
                                                                                            <span className='mx-1'>{items.created ? new Date(items.created).toLocaleDateString() : ' - '}</span>
                                                                                            <a target='_blank' href={`${CHAIN_INFO[currentChain].explorer}/tx/${items.tx_hash}`} rel="noreferrer">
                                                                                                <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
                                                                                            </a>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                        }


                                                                    </tbody>
                                                                </table>
                                                            }
                                                        </>
                                                    )}
                                                    {nftData && nftData.length > 0 &&
                                                        <div className='col-12 d-flex justify-content-center'>
                                                            <nav aria-label="Page navigation example">
                                                                <ul className="pagination pagination">
                                                                    <li>
                                                                        <button

                                                                            disabled={parseInt(pagination.currentPage) === 1 || parseInt(pagination.currentPage) === 0} // Disable if on the first page
                                                                            onClick={() => handlePageChange('prev')}
                                                                        >
                                                                            Previous
                                                                        </button>
                                                                    </li>
                                                                    {Array.from({ length: pagination.totalPages }, (_, index) => (
                                                                        <li key={index}>
                                                                            <button
                                                                                className={`${pagination.currentPage === index + 1
                                                                                    ? 'active'
                                                                                    : ''
                                                                                    }`}
                                                                                onClick={() => handlePageChange(index + 1)}
                                                                            >
                                                                                {index + 1}
                                                                            </button>
                                                                        </li>
                                                                    ))}
                                                                    <li>
                                                                        <button
                                                                            disabled={parseInt(pagination.currentPage) === parseInt(pagination.totalPages)} // Disable if on the last page
                                                                            onClick={() => handlePageChange('next')}
                                                                        >
                                                                            Next
                                                                        </button>
                                                                    </li>
                                                                </ul>
                                                            </nav>
                                                        </div>
                                                    }
                                                </>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </Layout>
    )
}
